<template>
    <loader v-if="loading"></loader>
    <div v-else-if="data">

        <div class="card mt-3">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4">
                        <router-link :to="{ name: 'userDetail', params: { id: data.user.id }}">
                            <h6>{{data.user.name}} {{data.user.surname}}</h6>
                            <p class="mb-1">+{{data.user.phoneNumber}}</p>
                            <span class="badge badge-primary">User</span>
                        </router-link>
                    </div>
                    <div class="col-md-4">
                        <div v-if="data.driver">
                            <router-link :to="{ name: 'userDetail', params: { id: data.driver.id }}">
                                <h6>{{data.driver.name}} {{data.driver.surname}}</h6>
                                <p class="mb-1">+{{data.driver.phoneNumber}}</p>
                                <span class="badge badge-success">Driver</span>
                            </router-link>
                        </div>
                        <span v-else class="badge badge-dark">NONE</span>
                    </div>
                    <div class="col-md-4">
                        <div v-if="data.vehicle">
                            <h6>{{data.vehicle.model.name}} -
                                {{data.vehicle.year}}</h6>
                            <p>{{data.vehicle.plate}}</p>
                        </div>
                        <span v-else class="badge badge-dark">NONE</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mt-3">
            <div class="card-header">
                Info - {{ data.createdAt | moment("DD/MM/YYYY HH:mm") }}
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <dl class="row">
                            <dt class="col-md-6">City</dt>
                            <dd class="col-md-6">
                                <span v-if="data.city">{{data.city.name}}</span>
                                <span v-else class="badge badge-dark">NONE</span>
                            </dd>

                            <dt class="col-md-6">Category</dt>
                            <dd class="col-md-6">
                                <span v-if="data.category">{{data.category.name}}</span>
                                <span v-else class="badge badge-dark">NONE</span>
                            </dd>

                            <dt class="col-md-6">Level</dt>
                            <dd class="col-md-6">
                                <span v-if="data.level">{{data.level.name}}</span>
                                <span v-else class="badge badge-dark">NONE</span>
                            </dd>
                        </dl>
                    </div>
                    <div class="col-md-6">
                        <dl class="row">
                            <dt class="col-md-6">Status</dt>
                            <dd class="col-md-6"><span class="badge badge-primary">{{data.status}}</span></dd>

                            <dt class="col-md-6">Active</dt>
                            <dd class="col-md-6">
                                <span v-if="data.active" class="badge badge-success">Active</span>
                                <span v-else class="badge badge-dark">None</span>
                            </dd>

                            <dt class="col-md-6">Pin Code</dt>
                            <dd class="col-md-6">{{data.pin}}</dd>
                        </dl>
                    </div>
                </div>
                <div v-if="data.tolls.length > 0" class="bg-light p-2">
                    <span v-for="toll in data.tolls" :key=toll.toll.id>{{toll.toll.name}} - {{toll.price}}₺</span>
                </div>
            </div>
        </div>


        <div class="card mt-3">
            <div class="card-header">
                Payment Info
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-6">
                        <dl class="row">
                            <dt class="col-sm-6">Status</dt>
                            <dd class="col-sm-6">
                                <span class="badge badge-info">{{data.payment.status}}</span>
                            </dd>

                            <dt class="col-sm-6">Start Price</dt>
                            <dd class="col-sm-6">{{data.payment.startPrice}}₺</dd>

                            <dt class="col-sm-6">Price Per Km</dt>
                            <dd class="col-sm-6">{{data.payment.pricePerKm}}₺</dd>

                            <dt class="col-sm-6">Min Price</dt>
                            <dd class="col-sm-6">{{data.payment.minPrice}}₺</dd>

                            <dt class="col-sm-6">Toll Price</dt>
                            <dd class="col-sm-6">{{data.payment.tollPrice}}₺</dd>

                            <dt class="col-sm-6">Distance Price</dt>
                            <dd class="col-sm-6">{{data.payment.distancePrice}}₺</dd>
                        </dl>
                    </div>
                    <div class="col-sm-6">
                        <dl class="row">
                            <dt class="col-sm-6">Price</dt>
                            <dd class="col-sm-6">{{data.payment.price}}₺</dd>

                            <dt class="col-sm-6">Commission Rate</dt>
                            <dd class="col-sm-6">{{data.payment.commission}}%</dd>

                            <dt class="col-sm-6">Commission Price</dt>
                            <dd class="col-sm-6">{{data.payment.commissionPrice}}₺</dd>

                            <dt class="col-sm-6">Driver Price</dt>
                            <dd class="col-sm-6">{{data.payment.driverPrice}}₺</dd>

                            <dt class="col-sm-6">Payment Commission</dt>
                            <dd class="col-sm-6">{{data.payment.providerCommissionFee}}%</dd>

                            <dt class="col-sm-6">Payment Commission Price</dt>
                            <dd class="col-sm-6">{{data.payment.providerCommissionAmount}}₺</dd>
                        </dl>
                    </div>
                </div>
                <div v-if="data.payment.paymentType === 'CARD'" class="bg-light p-2">
                    <div class="row">
                        <div class="col-md-10">
                            <span class="font-weight-bold">
                                {{data.payment.card.name}} - {{data.payment.card.cardBankName}} ({{data.payment.card.lastFourDigits}})
                            </span>
                        </div>
                        <div class="col-md-2 text-right">
                            <b-button size="sm" variant="danger" v-b-modal.refund>Refund {{data.payment.price}}₺</b-button>
                            <b-modal id="refund" title="Refund" @ok="() => refund()">
                                <p class="my-4">Refund {{data.payment.price}}₺ Confirmation</p>
                            </b-modal>
                        </div>
                    </div>
                </div>
                <div v-else class="bg-light p-2">
                    <span class="badge badge-warning">CASH PAYMENT</span>
                </div>
            </div>
        </div>

        <div class="card mt-3">
            <div class="card-header">
                Feedbacks
            </div>
            <div class="card-body">
                <div class="row">
                    <div v-for="feedback in data.feedbacks" :key="feedback.id" class="col-md-6">
                        <blockquote class="blockquote m-0">
                            <p class="mb-0"><span class="badge badge-light">{{feedback.gateway}}</span> - (
                                {{feedback.score}} )</p>
                            <footer class="blockquote-footer">
                                {{feedback.comment}}
                            </footer>
                        </blockquote>
                    </div>
                    <span v-if="data.feedbacks.length === 0" class="badge badge-dark">NONE</span>
                </div>
            </div>
        </div>

        <div class="card mt-3">
            <div class="card-header">
                Estimation
            </div>
            <div class="card-body p-0">
                <div class="p-3 pb-0">
                    Distance: {{(data.distance / 1000).toFixed(2)}}km
                </div>

                <GmapMap :options="{
                                   zoomControl: true,
                                   mapTypeControl: false,
                                   scaleControl: false,
                                   streetViewControl: false,
                                   rotateControl: false,
                                   fullscreenControl: true,
                                   disableDefaultUI: false
                                }"
                         :zoom="12"
                         id="map"
                         :center="{lat:data.pickupLocation.coordinates[1], lng:data.pickupLocation.coordinates[0]}">

                    <gmap-polyline :path="polyline"></gmap-polyline>

                    <GmapMarker v-if="google"
                                :position="new google.maps.LatLng(data.pickupLocation.coordinates[1], data.pickupLocation.coordinates[0])"
                                :icon="{ url: require('../../../assets/start-line.png')}"/>
                    <GmapMarker v-if="google" :position="new google.maps.LatLng(data.destinationLocation.coordinates[1], data.destinationLocation.coordinates[0])"
                                :icon="{ url: require('../../../assets/finish.png')}"/>
                </GmapMap>
            </div>
        </div>

        <div class="card mt-3 mb-5">
            <div class="card-header">
                Waypoint & Actions
            </div>
            <div class="card-body p-0">
                <div class="row">
                    <div class="col-md-3 pr-0">
                        <div class="list-group" id="actions">
                            <div v-for="action in data.actions" :key="action.id"
                                 @mouseover="activeAction = action.id"
                                 class="list-group-item list-group-item-action border-left-0 border-top-0 rounded-0">
                                <p class="mb-1 font-weight-bold">{{action.user.name}} {{action.user.surname}} <small class="float-right">{{ action.createdAt | moment("HH:mm:ss") }}</small></p>
                                <small class="badge badge-success">{{action.status}}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9 pl-0">
                        <GmapMap :options="{
                                   zoomControl: true,
                                   mapTypeControl: false,
                                   scaleControl: false,
                                   streetViewControl: false,
                                   rotateControl: false,
                                   fullscreenControl: true,
                                   disableDefaultUI: false
                                }"
                                 :zoom="12"
                                 id="map2"
                                 :center="{lat:data.pickupLocation.coordinates[1], lng:data.pickupLocation.coordinates[0]}">

                            <gmap-polyline v-if="arrivingPolyline.length > 0" :options="{ strokeColor: '#FF0000'}" :path="arrivingPolyline"></gmap-polyline>
                            <gmap-polyline v-if="ontripPolyline.length > 0" :path="ontripPolyline"></gmap-polyline>

                            <div v-for="action in data.actions" :key=action.id>
                                <GmapMarker v-if="google && activeAction === action.id" :position="new google.maps.LatLng(action.location.coordinates[1], action.location.coordinates[0])"/>
                            </div>
                        </GmapMap>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import ContentLoader from "../../../components/ContentLoader";
    import GetTrip from '../../../store/actions/getTrip';
    import RefundTripPayment from '../../../store/actions/refundTripPayment';
    import ShowError from "../../../helpers/showError";
    import {gmapApi} from 'vue2-google-maps'

    export default {
        name: 'TripDetail',
        components: {
            loader: ContentLoader,
        },
        computed: {
            google: gmapApi
        },
        data() {
            return {
                loading: false,
                data: false,
                activeAction: false,
                polyline: [],
                arrivingPolyline: [],
                ontripPolyline: [],
            }
        },
        created() {
            this.load();
        },
        methods: {
            async refund(){
                await RefundTripPayment(this.$route.params.id);
                this.load();
            },
            async load() {
                try {
                    this.loading = true;
                    this.data = await GetTrip(this.$route.params.id);
                    this.polyline = this.data.direction.coordinates.map(c => ({lat: c[1], lng: c[0]}));
                    if(this.data.waypoint){
                        this.arrivingPolyline = this.data.waypoint.arriving.coordinates.map(c => ({lat: c[1], lng: c[0]}));
                        this.ontripPolyline = this.data.waypoint.ontrip.coordinates.map(c => ({lat: c[1], lng: c[0]}));
                    }

                } catch (e) {
                    ShowError(this, e);
                } finally {
                    this.loading = false;
                }
            }
        }
    }
</script>


<style scoped>
    #map {
        width: 100%;
        height: 350px;
    }
    #map2 {
        width: 100%;
        height: 500px;
    }
    #actions {
        height: 500px;
        overflow-x: scroll;
    }
</style>
